export default __webpack_public_path__ + "static/media/EAST1000.34I-33305_-18308_0.b6529b6e.jpg";